import React from 'react';
import TextWidget from '../TextWidget/TextWidget'
import agent from '../../../../agent';
import { connect } from 'react-redux';
import LoaderWidget from '../Loader/LoaderWidget'
import {checkForUnauthorisedResponse} from '../../../Utils/ErrorHandler'

const mapStateToProps = state => ({
  notification:state.signin.notification
});

class EmployeeCountWidget extends React.Component {

  constructor() {
    super();
    this.state = {
      count: 0,
      loaded:false
    };
  }

  componentDidMount() {
    this.loadEmployees()
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkIfEmployeeUpdateNeeded(prevProps);
  }

  checkIfEmployeeUpdateNeeded(prevProps) {
    const oldNotification = prevProps.notification ? prevProps.notification.notification : null;
    const newNotification = this.props.notification ? this.props.notification.notification : null;
    const oldType = prevProps.notification ? prevProps.notification.type : null;
    const newType = this.props.notification ? this.props.notification.type : null;

    if((!oldNotification && newNotification && newNotification.location === this.props.locationName) ||
       (oldNotification && oldNotification.name !== newNotification.name && newNotification.location === this.props.locationName) ||
       (oldNotification && oldType !== newType && newNotification.location === this.props.locationName))  {
      this.loadEmployees();
    }
  }

  loadEmployees() {

    const location = this.props.locationName;

    agent.Entity.getEmployees().then(
      res => {
        if(res.result) {
          var count = 0;
          for(var i = 0; i < res.data.length; i++) {
            if(res.data[i].status && res.data[i].status.location === location) {
               count++;
             }
          }

          this.setState({
            ...this.state,
            count:count,
            loaded:true
          })
        } else {
          this.setState({
            ...this.state,
            loaded:true
          })
        }
      },
      error => {
        if(!checkForUnauthorisedResponse(error, agent)) {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      }
    )

  }


  render() {
    if(this.state.loaded) {
      return (
        <TextWidget {...this.props} onWidgetRefresh={this.loadEmployees.bind(this)} refreshInterval={1800} value={this.state.count} />
      )
    } else {
      return (
        <LoaderWidget {...this.props}/>
      )
    }
  }
}

export default connect(mapStateToProps)(EmployeeCountWidget);



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/EmployeeCountWidget/EmployeeCountWidget.js